import React from 'react';
import { Button } from '../Button';
import { Input } from '../Input';
import { Textarea } from '../Textarea';
import { Label } from '../Label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../Select';
import { Field, FieldGroup, FieldLabel } from '../Field';
export function Contact() {
  return <section id="contact" className="py-20 md:py-32 bg-brand-gray" data-id="element-79">
      <div className="container mx-auto px-4 md:px-6" data-id="element-80">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-81">
          {/* Left Column: Form */}
          <div className="bg-brand-white p-8 md:p-12 rounded-3xl shadow-sm border border-brand-sky/30" data-id="element-82">
            <div className="mb-8" data-id="element-83">
              <h2 className="font-display font-bold text-3xl md:text-4xl text-brand-navy mb-4" data-id="element-84">
                Get in Touch
              </h2>
              <p className="text-brand-navy/70 text-lg" data-id="element-85">
                Let us know how we can assist you and what you can expect from
                our cleaning services.
              </p>
            </div>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-86">
              <FieldGroup className="space-y-4" data-id="element-87">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-88">
                  <Field data-id="element-89">
                    <FieldLabel htmlFor="name" className="text-brand-navy font-semibold" data-id="element-90">
                      Name
                    </FieldLabel>
                    <Input id="name" placeholder="Your name" className="h-12 rounded-xl border-brand-sky bg-brand-gray/50 focus-visible:ring-brand-aqua" data-id="element-91" />
                  </Field>
                  <Field data-id="element-92">
                    <FieldLabel htmlFor="phone" className="text-brand-navy font-semibold" data-id="element-93">
                      Phone
                    </FieldLabel>
                    <Input id="phone" type="tel" placeholder="Your phone number" className="h-12 rounded-xl border-brand-sky bg-brand-gray/50 focus-visible:ring-brand-aqua" data-id="element-94" />
                  </Field>
                </div>

                <Field data-id="element-95">
                  <FieldLabel htmlFor="email" className="text-brand-navy font-semibold" data-id="element-96">
                    Email
                  </FieldLabel>
                  <Input id="email" type="email" placeholder="Your email address" className="h-12 rounded-xl border-brand-sky bg-brand-gray/50 focus-visible:ring-brand-aqua" data-id="element-97" />
                </Field>

                <Field data-id="element-98">
                  <FieldLabel htmlFor="service" className="text-brand-navy font-semibold" data-id="element-99">
                    Service Needed
                  </FieldLabel>
                  <Select data-id="element-100">
                    <SelectTrigger id="service" className="h-12 rounded-xl border-brand-sky bg-brand-gray/50 focus:ring-brand-aqua" data-id="element-101">
                      <SelectValue placeholder="Select a service" data-id="element-102" />
                    </SelectTrigger>
                    <SelectContent data-id="element-103">
                      <SelectItem value="standard" data-id="element-104">
                        Standard Cleaning
                      </SelectItem>
                      <SelectItem value="deep" data-id="element-105">Deep Cleaning</SelectItem>
                      <SelectItem value="moveout" data-id="element-106">Move Out Cleaning</SelectItem>
                      <SelectItem value="airbnb" data-id="element-107">Airbnb Cleaning</SelectItem>
                    </SelectContent>
                  </Select>
                </Field>

                <Field data-id="element-108">
                  <FieldLabel htmlFor="message" className="text-brand-navy font-semibold" data-id="element-109">
                    Message
                  </FieldLabel>
                  <Textarea id="message" placeholder="Tell us about your space and needs..." className="min-h-[120px] rounded-xl border-brand-sky bg-brand-gray/50 focus-visible:ring-brand-aqua resize-none" data-id="element-110" />
                </Field>
              </FieldGroup>

              <Button className="w-full bg-brand-aqua hover:bg-brand-aqua-dark text-white h-14 text-lg font-semibold rounded-xl mt-4" data-id="element-111">
                Send Message
              </Button>
            </form>
          </div>

          {/* Right Column: Info Blocks */}
          <div className="flex flex-col justify-center" data-id="element-112">
            <div className="bg-brand-sky rounded-3xl p-8 md:p-12 flex flex-col gap-8" data-id="element-113">
              <div className="bg-brand-white p-8 rounded-2xl shadow-sm" data-id="element-114">
                <h3 className="font-display font-bold text-2xl text-brand-navy mb-3" data-id="element-115">
                  Hours
                </h3>
                <p className="text-brand-navy/80 text-lg" data-id="element-116">
                  24/7 for your convenience.
                </p>
              </div>

              <div className="bg-brand-white p-8 rounded-2xl shadow-sm" data-id="element-117">
                <h3 className="font-display font-bold text-2xl text-brand-navy mb-3" data-id="element-118">
                  Contact
                </h3>
                <div className="flex flex-col gap-2" data-id="element-119">
                  <a href="mailto:info@deepcleancleaners.com" className="text-brand-aqua hover:text-brand-aqua-dark font-medium text-lg transition-colors" data-id="element-120">
                    info@deepcleancleaners.com
                  </a>
                  <a href="tel:4637772838" className="text-brand-aqua hover:text-brand-aqua-dark font-medium text-lg transition-colors" data-id="element-121">
                    (463) 777-2838
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}